import React from 'react'
import ProfileImageWithFallback from '../../../common/ProfileImageWithFallback'
import CloudStorage from '../../../CloudStorage/CloudStorage'
import WebVersionInfo from './WebVersionInfo'

export default function ProfileModel({
    dropdownRefs,
    isMobile,
    openDropdown,
    onhover3,
    handleDropdownButtonClick,
    setOnhover3,
    profile,
    isThisMobileScreen,
    handleMobileNavigation,
    getModalToggleHandler,
    t,
    lan
}) {
    return (
        <div>
            <div
                ref={dropdownRefs.onhover3}
                className={(isMobile ? openDropdown == 'onhover3' : onhover3) ? "dropdown active" : "dropdown"}
            >
                <button
                    className="btn dropdown-toggle"
                    onClick={() => handleDropdownButtonClick('onhover3')}
                    onMouseEnter={() => !isMobile && setOnhover3(true)}
                    onMouseLeave={() => !isMobile && setOnhover3(false)}
                >
                    <ProfileImageWithFallback url={profile.profile_image} />
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/menu.svg`}
                        alt=""
                    />
                </button>
                {(isMobile ? openDropdown == 'onhover3' : onhover3) && (
                    <div className="dropdown-cont mobile-menu-header"
                        onClick={() => setOnhover3('onhover6')}
                        onMouseEnter={() => !isThisMobileScreen && setOnhover3(true)}
                        onMouseLeave={() => !isThisMobileScreen && setOnhover3(false)}
                    >
                        <div className="text-center profile-img">
                            <h1>
                                {(profile?.company ? "Company" : profile?.expert ? "Expert" : "User")}
                            </h1>
                            <ProfileImageWithFallback url={profile.profile_image} />
                            <h1>{profile.first_name} {profile.last_name}</h1>
                            <p>{profile.email_id}</p>
                            <button
                                onClick={() => handleMobileNavigation(`/${lan}/dashboard`)}
                                className="btn"
                            >
                                {t("View profile")}
                            </button>
                        </div>
                        <div className="dropdown-link">
                            <a onClick={() => handleMobileNavigation(`/${lan}/dashboard`)}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/dashboard.svg`}
                                    alt=""
                                />
                                {t("Dashboard")}
                            </a>
                            <a onClick={() => handleMobileNavigation(`/${lan}/dashboard/myorders`)}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/cart.svg`}
                                    alt=""
                                />
                                {t("My Orders")}
                            </a>
                            <a onClick={() => handleMobileNavigation(`/${lan}/dashboard/managework/projects`)}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/work.svg`}
                                    alt=""
                                />
                                {t("Manage Work")}
                            </a>
                            <a onClick={() => handleMobileNavigation(`/${lan}/dashboard/manageteams`)}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/team.svg`}
                                    alt=""
                                />
                                {t("Team")}
                            </a>
                            <a onClick={() => handleMobileNavigation(`/${lan}/dashboard/contactus`)}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/help.svg`}
                                    alt=""
                                />
                                {t("Help & Support")}
                            </a>
                            <a >
                                <WebVersionInfo />
                            </a>
                        </div>
                        <div className="logout">
                            <a onClick={getModalToggleHandler('logout')}>
                                <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/logout.svg`}
                                    alt=""
                                />
                                {t("Sign Out")}
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
